import React from "react";

import { GetFarmDocScanFieldResponse } from "models";

import { Icon, Typography } from "components";

import {
  DOC_SCAN_CONFIDENCE_LABELS,
  DOC_SCAN_CONFIDENCE_TONES,
  DOC_SCAN_IDENTIFIERS,
  countMatchingIdentifiers,
} from "pages/admin/verifications/utils/docScanEvidenceDrawer";

export const DocScanFieldMatch = ({ evidence }: { evidence: GetFarmDocScanFieldResponse }) => {
  const { identifiers, confidence, farmerConfirmed, overlap, comparison } = evidence;

  return (
    <div className="doc-scan-field-match">
      <div className="doc-scan-field-match-header">
        <Typography variant="paragraph-l" bold>
          Field match · {countMatchingIdentifiers(identifiers)}/{DOC_SCAN_IDENTIFIERS.length} identifiers
        </Typography>
        <span className={`doc-scan-confidence ${DOC_SCAN_CONFIDENCE_TONES[confidence]}`}>{DOC_SCAN_CONFIDENCE_LABELS[confidence]}</span>
      </div>
      <ul className="doc-scan-identifiers">
        {DOC_SCAN_IDENTIFIERS.map(({ key, label }) => (
          <li key={key} className={`doc-scan-identifier ${identifiers[key] ? "success" : "danger"}`}>
            <Icon iconName={identifiers[key] ? "tabler/check" : "tabler/x"} size="s" />
            {label}
          </li>
        ))}
      </ul>
      {overlap && (
        <Typography variant="paragraph-s" color="grey-600">
          Shape overlap {overlap.overlapPct === null ? "unknown" : `${overlap.overlapPct}%`} · parcel center {overlap.location ? "inside" : "outside"} the field
        </Typography>
      )}
      {farmerConfirmed && (
        <div className="doc-scan-farmer-confirmed">
          <Icon iconName="tabler/user-check" size="s" />
          Farmer confirmed this match for {comparison.fieldName.platform ?? "this field"}
        </div>
      )}
    </div>
  );
};
